import { useQuery } from "@tanstack/react-query";

import { usePortalContext } from "@/hooks/usePortalContext";
import { useTRPC } from "@/trpc/client";

const STALE_TIME = 5 * 60_000;

export const useOrgAnalytics = (yearMonth: string | undefined) => {
  const trpc = useTRPC();
  const { context } = usePortalContext();
  const orgId = context?.type === "org" ? context.id : undefined;

  return useQuery({
    ...trpc.analytics.org.queryOptions({
      rentalsOrgId: orgId ?? "",
      yearMonth: yearMonth ?? "",
    }),
    enabled: !!orgId && !!yearMonth,
    staleTime: STALE_TIME,
  });
};
